import { useParams } from 'react-router-dom';
import { PageContainer } from '../../../shared/components/PageContainer';
import { FeriasPainel } from '../components/FeriasPainel';
import { useVisaoFerias } from '../hooks/ferias';

/** Gestor: Visão 360º das férias de um liderado direto (US-GP-014, seção 4.9). */
export default function FeriasLideradoPage() {
  const { userId = '' } = useParams();
  const visao = useVisaoFerias({ kind: 'team', userId }, !!userId);
  const nome = visao.data?.identification.name;
  return (
    <PageContainer
      title={nome ? `Férias — ${nome}` : 'Férias do liderado'}
      breadcrumbs={[{ label: 'Meus Colaboradores', to: '/meus-colaboradores' }, { label: 'Férias' }]}
    >
      <FeriasPainel scope={{ kind: 'team', userId }} />
    </PageContainer>
  );
}
